module.exports = __webpack_public_path__ + "static/media/piyush_deshpande.5a1d8b9a.png";